import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import { FormattedMessage, useIntl } from "react-intl";
import { editSocial, getAllSocialTypes, getSocial } from "store/actions";
import Loader from "components/shared/Loader";
import { Input } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { getId } from "helpers/functions";

const EditSocial = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();
  const { loading, error, social } = useSelector((state) => state.socials);
  const { socialTypes } = useSelector((state) => state.socialTypes);

  const {
    register,
    handleSubmit,
    reset,

    formState: { errors },
  } = useForm();

  // effects
  useEffect(() => {
    dispatch(getSocial(id));
    if (socialTypes?.length === 0) dispatch(getAllSocialTypes());
    // dispatch(getSection({ page: "socials", slug: id }));
  }, [dispatch, id, socialTypes]);

  useEffect(() => {
    // reset(social);
    reset({
      ...social,
      socialType: getId(social?.socialType),
    });
  }, [reset, social, locale]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const renderCategoriesOptions = socialTypes?.map((item) => (
    <option value={getId(item)}>{item?.name?.[locale]}</option>
  ));
  const onSubmit = (data) => {
    // if (!selectedImage?.path) {
    //   toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
    //   return;
    // }
    // data.image = `/uploads/${selectedImage?.path?.split("/").pop()}`;
    dispatch(editSocial({ id, data, navigate }));
  };
  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"editSocial"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={8} md={12}>
                <Col xs={12}>
                  <div className="form-group required">
                    <h5>نوع وسيلة التواصل</h5>
                    <div>
                      <select
                        style={{ backgroundPosition: "left 0.70rem center" }}
                        className="form-control form-select"
                        {...register("socialType", { required: true })}
                      >
                        <option>اختر التصنيف</option>
                        {renderCategoriesOptions}
                      </select>
                    </div>
                    <p className="error-hint">
                      {errors.socialType?.type === "required" && (
                        <FormattedMessage id="required" />
                      )}
                    </p>
                  </div>
                </Col>
                {/* name  */}
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="name"
                      name="name"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="link"
                      name="link"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSocial;
